import {useState} from 'react'
import {Box, Text} from '@chakra-ui/react'
import {CloseIcon} from '@chakra-ui/icons'
import {PropTypes} from 'prop-types'

const EmailPill = ({email, onRemove, bg, fontColor}) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      bg={bg}
      border="1px solid"
      borderColor="neutral.600"
      borderRadius="md"
      px={1}
      position="relative"
      onMouseEnter={() => onRemove && setIsHovered(true)}
      onMouseLeave={() => onRemove && setIsHovered(false)}
      cursor={onRemove ? 'pointer' : 'default'}
      onClick={onRemove}
      _hover={onRemove ? {bg: 'neutral.300'} : {}}
    >
      <Text
        fontSize="16px"
        fontWeight="regular"
        color={fontColor}
        lineHeight="150%"
      >
        {email}
      </Text>
      {onRemove && isHovered && (
        <CloseIcon ml={1} boxSize="10px" color="neutral.600" />
      )}
    </Box>
  )
}

EmailPill.propTypes = {
  email: PropTypes.string.isRequired,
  onRemove: PropTypes.func,
  bg: PropTypes.string,
  fontColor: PropTypes.string,
}

EmailPill.defaultProps = {
  onRemove: null,
  bg: 'neutral.200',
  fontColor: 'mld.primary.100',
}

export default EmailPill
